<template>
    <Header />
    <router-view />
    <Footer />
</template>

<script>
import Header from "@/components/common/Header.vue";
import Footer from "@/components/common/Footer.vue";

export default {
  name: "DefaultLayout",
  components: {
    Header,
    Footer,
  },
};
</script>

<style scoped>
@import "@/assets/css/cert.css";
@import "@/assets/css/reset.css";
@import "@/assets/css/glyphicon.css";
@import "@/assets/css/ntax.css";
@import "@/assets/css/ntaxAPI.css";
@import "@/assets/css/font_eval_m.css";
@import "@/assets/css/font-awesome.css";
</style>
